import dayjs from "dayjs";

const getDaysInMonth = (year, month) => {
  return dayjs(new Date(year, month)).daysInMonth();
};

const getPreviousMonthDays = (year, month) => {
  const firstDayOfMonth = dayjs(new Date(year, month, 1));
  const firstDayOfWeek = firstDayOfMonth.day();

  const lastNDays = [];

  if (firstDayOfWeek) {
    const lastDayOfPrevMonth = dayjs(new Date(year, month, 0));

    for (let i = 0; i < firstDayOfWeek; i++) {
      const day = lastDayOfPrevMonth.subtract(i, "day");
      lastNDays.push(day.date());
    }

    return lastNDays.reverse();
  }

  return lastNDays;
};

const getNextMonthDays = (year, month) => {
  const daysInMonth = getDaysInMonth(year, month);
  const lastDayOfWeek = dayjs(new Date(year, month, daysInMonth)).day();

  const firstNDays = [];
  if (lastDayOfWeek < 6) {
    for (let i = 1; i <= 6 - lastDayOfWeek; i++) {
      const day = dayjs(new Date(year, month + 1, i));
      firstNDays.push(day.date());
    }
  }

  return firstNDays;
};

export const renderCalendar = (year, month) => {
  const result = [];
  const prevMonthDate = getPreviousMonthDays(year, month);
  const nextMonthDate = getNextMonthDays(year, month);

  const daysInMonth = getDaysInMonth(year, month);

  prevMonthDate.forEach((day) => {
    result.push({
      value: day,
      disabled: true,
    });
  });

  for (let i = 1; i <= daysInMonth; i++) {
    result.push({
      value: i,
      disabled: false,
    });
  }

  nextMonthDate.forEach((day) => {
    result.push({
      value: day,
      disabled: true,
    });
  });

  return result;
};

export const isValidDate = (dateString) => {
  return dayjs(dateString).isValid();
};
